import React from 'react';
import styled from 'styled-components';
import StarSvg from '@src/assets/imgs/star.svg';
import useHover from '@src/hooks/useHover';
import LocationSvg from '@src/assets/imgs/blood-home/location.svg';
import { useRouter } from 'next/router';
import { useRecoilValue } from 'recoil';
import keywordSelector from '@src/recoils/selector/keyword';
import Highlighter from 'react-highlight-words';
import { devices, theme } from '@src/styles/theme';
type Props = {
  title: string;
  contentAddress: string;
  rating: number;
  reviewCount: number;
  uuid: string;
  kind: string;
};

const BloodDonationCard = ({
  title,
  contentAddress,
  rating,
  reviewCount,
  uuid,
  kind,
}: Props) => {
  const isStarActive = reviewCount > 0;
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const router = useRouter();
  const keywordHighLight = useRecoilValue(keywordSelector);
  return (
    <Container
      ref={hoverRef}
      onClick={() => {
        router.push(
          `/blood-home/reviews?id=${uuid}&name=${title}&address=${contentAddress}`
        );
      }}
    >
      <TitleWrapper>
        <Title>
          <Highlighter
            highlightStyle={{
              backgroundColor: 'transparent',
              color: theme.commonColor.pink004,
            }}
            searchWords={keywordHighLight}
            autoEscape={true}
            textToHighlight={title}
          >
            {title}
          </Highlighter>
        </Title>
      </TitleWrapper>
      <InfoWrapper isHover={isHovered}>
        <BloodKindDivider>
          {kind === 'RED_CROSS' ? '대한적십자사' : '한마음혈액원'}
        </BloodKindDivider>
        <StarDivider isActive={isStarActive}>
          <StarIcon isActive={isStarActive} />
          <Rating>{`${rating}점 (${reviewCount})`}</Rating>
        </StarDivider>
      </InfoWrapper>
      {isHovered && (
        <HoverWrap>
          <Flex>
            <div>
              <Icon />
            </div>
            <Text>{contentAddress}</Text>
          </Flex>
          {/* <Flex
            style={{
              paddingTop: 4,
            }}
          >
            <div>월화</div>
            <Text>시간대~~</Text>
          </Flex> */}
        </HoverWrap>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 33%;
  padding: 30px 20px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  &:hover {
    background: rgba(0, 0, 0, 0.7);
    background-color: rgba(0, 0, 0, 0.7);
    transition: 0.5s all;
    z-index: 99999;
  }
  @media ${devices.tablet} {
    width: 49%;
    padding: 15px 10px;
  }
`;

const TitleWrapper = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.6px;
  @media ${devices.tablet} {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 112.5% */
    letter-spacing: -0.6px;
  }
`;

const Title = styled.div`
  white-space: pre-wrap;
`;

const StarIcon = styled(({ isActive, ...props }) => <StarSvg {...props} />)<{
  isActive: boolean;
}>`
  width: 15px;
  height: 15px;
  & > path {
    fill: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.yellow002 : theme.commonColor.gray003};
    stroke: ${({ theme, isActive }) =>
      isActive ? theme.commonColor.yellow002 : theme.commonColor.gray003};
  }
  @media ${devices.tablet} {
    width: 12px;
    height: 12px;
  }
`;

const Rating = styled.div`
  /* font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.6px; */
`;

const InfoWrapper = styled.div<{ isHover: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  padding-top: 10px;
  opacity: ${({ isHover }) => (isHover ? '0.4' : '1')};
`;

const StarDivider = styled.div<{ isActive: boolean }>`
  padding: 5px 8px;
  font-family: 'Var';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.36px;
  border-radius: 3px;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.commonColor.yellow001 : theme.commonColor.gray002};
  color: ${({ theme, isActive }) =>
    isActive ? theme.commonColor.yellow002 : theme.commonColor.gray004};
  width: fit-content;
  display: flex;
  align-items: center;
  @media ${devices.tablet} {
    padding: 5px 4px;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.12px;
  }
`;

const BloodKindDivider = styled.div`
  padding: 5px 8px;
  font-family: 'Var';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.12px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.commonColor.pink002};
  color: ${({ theme }) => theme.commonColor.pink004};
  width: fit-content;
  @media ${devices.tablet} {
    padding: 5px 4px;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.12px;
  }
`;

const HoverWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.commonColor.white};
  z-index: 2;
  width: 100%;
  padding: 30px;
  /* margin: 0 auto; */
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
const Time = styled.div`
  padding-top: 6px;
`;

const Icon = styled(LocationSvg)``;

const Text = styled.div`
  padding-left: 10px;
`;

export default BloodDonationCard;
